export const contact_fields = [
  {
    key: 'First Name',
    field_label: 'rs_first_name',
    custom_field_id: 'c1',
    disable_mandatory: 1
  },
  {
    key: 'Last Name',
    field_label: 'rs_last_name',
    custom_field_id: 'c2',
    disable_mandatory: 1
  },
  {
    key: 'Address1',
    field_label: 'rs_address1',
    custom_field_id: 'c3'
  },
  {
    key: 'Address2',
    field_label: 'rs_address2',
    custom_field_id: 'c4'
  },
  {
    key: 'City',
    field_label: 'rs_city',
    custom_field_id: 'c5'
  },
  {
    key: 'Postalcode',
    field_label: 'rs_postalcode',
    custom_field_id: 'c6'
  },
  {
    key: 'Country',
    field_label: 'rs_country',
    custom_field_id: 'c7'
  },
  {
    key: 'Phone1',
    field_label: 'rs_phone1',
    custom_field_id: 'c8'
  },
  {
    key: 'Phone2',
    field_label: 'rs_phone2',
    custom_field_id: 'c9'
  },
  {
    key: 'Email1',
    field_label: 'rs_email1',
    custom_field_id: 'c10'
  },
  {
    key: 'Fax1',
    field_label: 'rs_fax1',
    custom_field_id: 'c11'
  },
  {
    key: 'Skype',
    field_label: 'rs_skype',
    custom_field_id: 'c12'
  }
];

export const location_fields = [
  {
    key: 'Venue Name',
    field_label: 'rs_venue_name',
    custom_field_id: 'l1',
    disable_mandatory: 1
  },
  {
    key: 'Address1',
    field_label: 'rs_address1',
    custom_field_id: 'l2'
  },
  {
    key: 'Address2',
    field_label: 'rs_address2',
    custom_field_id: 'l3'
  },
  {
    key: 'City',
    field_label: 'rs_city',
    custom_field_id: 'l4'
  },
  {
    key: 'Postalcode',
    field_label: 'rs_postalcode',
    custom_field_id: 'l5'
  },
  {
    key: 'Country',
    field_label: 'rs_country',
    custom_field_id: 'l6'
  },
  {
    key: 'Phone1',
    field_label: 'rs_phone1',
    custom_field_id: 'l7'
  },
  {
    key: 'Url',
    field_label: 'rs_url',
    custom_field_id: 'l8'
  },
  {
    key: 'Capacity',
    field_label: 'rs_capacity',
    custom_field_id: 'l9'
  }
];

export const promoter_fields = [
  {
    key: 'Promoter Name',
    field_label: 'rs_promoter_name',
    custom_field_id: 'p1',
    disable_mandatory: 1
  },
  {
    key: 'Legal / Representative',
    field_label: 'rs_legal_representative',
    custom_field_id: 'p2'
  },
  {
    key: 'Address1',
    field_label: 'rs_address1',
    custom_field_id: 'p3'
  },
  {
    key: 'Address2',
    field_label: 'rs_address2',
    custom_field_id: 'p4'
  },
  {
    key: 'City',
    field_label: 'rs_city',
    custom_field_id: 'p5'
  },
  {
    key: 'Postalcode',
    field_label: 'rs_postalcode',
    custom_field_id: 'p6'
  },
  {
    key: 'Country',
    field_label: 'rs_country',
    custom_field_id: 'p7'
  },
  {
    key: 'Phone1',
    field_label: 'rs_phone1',
    custom_field_id: 'p8'
  },
  {
    key: 'Phone2',
    field_label: 'rs_phone2',
    custom_field_id: 'p9'
  },
  {
    key: 'Email',
    field_label: 'rs_email',
    custom_field_id: 'p10'
  },
  {
    key: 'VAT ID',
    field_label: 'rs_vat_id',
    custom_field_id: 'p11'
  },
  {
    key: 'Tax No',
    field_label: 'rs_tax_no',
    custom_field_id: 'p12'
  }
];

export const artist_fields = [
  {
    key: 'Artist',
    field_label: 'rs_artist',
    custom_field_id: 'a1'
  },
  {
    key: 'Offer',
    field_label: 'rs_offer',
    custom_field_id: 'a2'
  },
  {
    key: 'Duration',
    field_label: 'rs_duration',
    custom_field_id: 'a3'
  },
  {
    key: 'Showtime',
    field_label: 'rs_showtime',
    custom_field_id: 'a4'
  },
  {
    key: 'Soundcheck',
    field_label: 'rs_soundcheck',
    custom_field_id: 'a5'
  },
  {
    key: 'Artist Before',
    field_label: 'rs_artist_before',
    custom_field_id: 'a6'
  },
  {
    key: 'Artist After',
    field_label: 'rs_artist_after',
    custom_field_id: 'a7'
  },
  {
    key: 'Stage Floor',
    field_label: 'stage_floor',
    custom_field_id: 'a8'
  }
];

export const event_fields = [
  {
    key: 'Date',
    field_label: 'rs_date',
    custom_field_id: 'e1',
    disable_questionnaire: 1
  },
  {
    key: 'Event Name',
    field_label: 'rs_event_name',
    custom_field_id: 'e2'
  },
  {
    key: 'Event URL',
    field_label: 'event_url',
    custom_field_id: 'e9'
  },
  {
    key: 'Line Up',
    field_label: 'rs_line_up',
    custom_field_id: 'e3'
  },
  {
    key: 'Doors',
    field_label: 'rs_doors',
    custom_field_id: 'e4'
  },
  {
    key: 'Curfew',
    field_label: 'rs_curfew',
    custom_field_id: 'e5'
  },
  {
    key: 'Airport Map',
    field_label: 'rs_airport_map',
    custom_field_id: 'e7'
  },
  {
    key: 'Travel',
    field_label: 'rs_travel',
    custom_field_id: 'e8',
    disable_request: 1,
    disable_mandatory: 1
  },
  {
    key: 'FLYER',
    field_label: 'rs_flyer',
    custom_field_id: 'e10',
    disable_request: 1,
    disable_mandatory: 1
  }
];